/** A name compared ignoring accents, case and surrounding or repeated spaces. */
export const comparableName = (name: string) =>
  name
    .normalize('NFD')
    .replace(/\p{M}+/gu, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

const collapsed = (name: string) => name.replace(/\s+/g, ' ').trim();

/**
 * The org unit (job title, department) whose name matches one of `names`,
 * ignoring accents, case and spacing. Names are tried in order, so a hire's
 * English job title wins over its French one. When several units match the
 * same name, the one spelled exactly like it wins, then the one that differs
 * only by case (accents kept), then the first.
 */
export const matchOrgUnitByName = <T extends { name: string }>(
  units: readonly T[],
  names: readonly (string | null | undefined)[]
): T | undefined => {
  for (const name of names) {
    if (!name?.trim()) continue;
    const wanted = comparableName(name);
    const matches = units.filter(
      (unit) => comparableName(unit.name) === wanted
    );
    if (!matches.length) continue;
    const exact = collapsed(name);
    return (
      matches.find((unit) => collapsed(unit.name) === exact) ??
      matches.find(
        (unit) => collapsed(unit.name).toLowerCase() === exact.toLowerCase()
      ) ??
      matches[0]
    );
  }
  return undefined;
};
